$(document).ready(function () {
    $('.product-item__image-link, .product-card-mini__image-link').on('touchstart', function () {
      const $btn = $(this).find('.btn_card')
      $btn.css('display', 'flex')
  
      clearTimeout($btn.data('timeoutId'))
      const timeoutId = setTimeout(() => {
        $btn.css('display', 'none')
      }, 2000)
  
      $btn.data('timeoutId', timeoutId)
    })

    // $(document).on('click', '.product-form__cart-submit', function() {
    //     if ($('.quick-cart__empty-state').length > 0) {
    //       setTimeout(function() {
    //         location.reload();
    //           }, 450);
    //     }
    // });
  })
  